import { ChevronDown, Search } from "lucide-react";
import { AREAS, SORTS } from "../lib/constants";
import { useTopics } from "../hooks/useTopics";

export const SearchForm = ({ value, onChange, onSubmit, compact = false, id = "q" }) => (
  <form role="search" onSubmit={(e) => { e.preventDefault(); onSubmit(); }} style={{ display: "flex", gap: 8, flex: compact ? "1" : "0 1 460px", minWidth: 0 }}>
    <label htmlFor={id} className="sr-only">Search proposals by place or idea</label>
    <div style={{ flex: 1, position: "relative" }}>
      <Search size={18} aria-hidden="true" style={{ position: "absolute", left: 15, top: "50%", transform: "translateY(-50%)", color: "var(--muted)" }} />
      <input id={id} type="search" className="inp" value={value} onChange={(e) => onChange(e.target.value)} data-testid={`${id}-search-input`}
        placeholder={compact ? "Search a place or idea" : "Search a place or idea, e.g. Shandon"}
        style={{ minHeight: compact ? 48 : 52, paddingLeft: 44, borderRadius: compact ? 14 : 12, borderColor: "var(--chip-border)" }} />
    </div>
    {!compact && <button type="submit" className="btn btn-primary" style={{ minHeight: 52, borderRadius: 12, fontSize: 16 }} data-testid={`${id}-search-btn`}>Search</button>}
  </form>
);

export const AreaChips = ({ area, onChange, scroll = false }) => (
  <div role="group" aria-label="Filter by area" className={scroll ? "chips-scroll" : "chips-row"} data-testid="area-filter">
    {["", ...AREAS].map((a) => (
      <button key={a || "all"} type="button" className="chip" aria-pressed={area === a} onClick={() => onChange(a)}
        data-testid={`area-chip-${(a || "all").toLowerCase().replace(/\s+/g, "-")}`}>
        {a || "All of Cork"}
      </button>
    ))}
  </div>
);

export const TopicSelect = ({ topic, onChange, small = false, id = "topic-filter" }) => {
  const topics = useTopics();
  const active = Boolean(topic);
  return (
    <div style={{ position: "relative", flex: "none" }} data-testid={`${id}-wrap`}>
      <label htmlFor={id} className="sr-only">Filter by topic</label>
      <select id={id} value={topic} onChange={(e) => onChange(e.target.value)} className={`chip${small ? " chip-sm" : ""}`} data-testid={id}
        style={{ appearance: "none", WebkitAppearance: "none", paddingRight: small ? 34 : 38, maxWidth: 220, textOverflow: "ellipsis",
          ...(active ? { background: "var(--ink-2)", borderColor: "var(--ink-2)", color: "#fff" } : {}) }}>
        <option value="">All topics</option>
        {topics.map((t) => <option key={t.id} value={t.id}>{t.name} ({t.count ?? 0}{t.count === 0 ? ", none yet" : ""})</option>)}
      </select>
      <ChevronDown size={16} aria-hidden="true" style={{ position: "absolute", right: small ? 12 : 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: active ? "#fff" : "var(--ink-2)" }} />
    </div>
  );
};

export const SortSeg = ({ sort, onChange, mobile = false }) => (
  <div role="group" aria-label="Sort proposals" className={`seg${mobile ? " seg-lg" : ""}`} data-testid="sort-control">
    {SORTS.map((s) => (
      <button key={s.key} type="button" aria-pressed={sort === s.key} onClick={() => onChange(s.key)} data-testid={`sort-${s.key}`}>
        {mobile && s.key === "liked" ? "Top" : s.label}
      </button>
    ))}
  </div>
);
